<!--
 * @Description: 员工时区设置
 * @Author: mdb
 * @Date: 2023-03-08 16:01:38
 * @LastEditTime: 2023-03-09 14:50:22
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        ref="tableRef"
        tableId="DcCosOFbuTimeZoneSetting"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="员工工号">
              <UserSelect v-model:value="queryForm.employeeNo" allowClear />
            </dc-form-item>
            <dc-form-item label="员工名称">
              <a-input v-model:value="queryForm.userName" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="部门">
              <CustomerAreaCascader type="search" appId="cos_ofbu" v-model:ids="queryForm.deptList" />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'ofbu_timeZone_add_btn'" type="primary" @click="handleChange()">新增</a-button>
        </template>

        <template #bodyCell="{ column, record }">
          <!-- <template v-if="column.key === 'deptName'">
            <CustomerAreaCascaderText appId="cos_ofbu" :value="text" />
          </template> -->

          <template v-if="column.dataIndex === 'action'">
            <a-button v-permission="'ofbu_clue_write_follow_btn'" type="link" @click="handleChange(record)"
              >编辑</a-button
            >
            <a-button v-permission="'ofbu_clue_del_btn'" type="link" @click="handleDelete(record)">删除</a-button>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 新增/编辑员工时区弹窗 -->
  <ModalForm ref="modalFormRef" @fetch="handleQueryChange('fetch')" />
</template>

<script setup lang="ts">
import { ref, reactive, computed } from 'vue'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import ModalForm from './components/ModalForm.vue'
import { timeZoneEnum } from './timeZoneEnum'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
// import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { personTimeZoneList, personTimeZoneDel } from '@/api/common'
import type { PersonTimeZoneParams, PersonTimeZoneListItem } from '@/typings/api/overseasSales'

const tableRef = ref()
const queryForm = reactive<PersonTimeZoneParams>({})
const columns = computed(() => [
  { title: '员工名称', dataIndex: 'userName' },
  { title: '员工工号', dataIndex: 'employeeNo' },
  { title: '部门', dataIndex: 'deptName' },
  { title: '时区', dataIndex: 'timeZoneId', minWidth: 450, dicData: timeZoneEnum },
  { title: '操作人', dataIndex: 'operatorName' },
  { title: '操作时间', dataIndex: 'createTime', width: 190 },
  { title: '操作', dataIndex: 'action', width: 190, fixed: 'right' }
])

const getList = (queryForm: PersonTimeZoneParams, callBack: (res: any) => void) => {
  personTimeZoneList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

// 新增/编辑员工时区弹窗
const modalFormRef = ref()
const handleChange = (rows?: PersonTimeZoneListItem) => {
  modalFormRef.value?.init(rows)
}
const handleDelete = (rows: PersonTimeZoneListItem) => {
  Modal.delete({
    content: '删除操作无法恢复，请谨慎操作',
    onOk() {
      personTimeZoneDel({ id: rows.id as number }).then(() => {
        message.success('删除成功')
        handleQueryChange('fetch')
      })
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuTimeZoneSetting' }
</script>

<style scoped></style>
